'use strict';

var HTTPService = require('../services/http-service');
var NotificationService = require('../services/notification-service');
var ReviewsService = require('../services/reviews-service');
var URL = require('../generic/url');
var Modal = require('./modal');
var Pace = require('./pace');

var $reviews = $('.js-reviews-avaliate');
var $reviewsScroll = $('.js-reviews-scroll');
var reviewsForm = '.reviews-form';
var search = URL.search(window.location.search);

var Reviews = {
  avaliate: function avaliate(event) {
    event.preventDefault();

    var $this = $(this);
    var me = blz.me || {};
    var data = {
      author: {
        id: me.id,
        givenName: $this.find('input[name="givenName"]').val().trim() || me.givenName,
        email: $this.find('input[name="email"]').val().trim() || me.email
      },
      itemReviewed: {
        compositionId: $this.data('sku'),
        brandSlugName: $this.data('brandslugname')
      },
      reviewBody: $this.find('#reviewBody').val().trim(),
      rating: {
        ratingValue: $this.find('#ratingValue').rating('rate') || 0
      }
    };

    if (
      !data.itemReviewed.compositionId ||
      !data.reviewBody ||
      !data.rating.ratingValue ||
      !data.author.email
    ) {
      return NotificationService.warning('all_fields_required');
    }

    Pace.open();

    ReviewsService.rate(data)
      .then(HTTPService.handleClientError)
      .then(function () {
        NotificationService.success('Sua avaliação foi enviada com sucesso para aprovação.');
        Modal.close();
      })
      .catch(NotificationService.warning)
      .always(function () {
        setTimeout(Pace.close, 1000);
      });
  },

  scroll: function goToReviews(event) {
    event && event.preventDefault();
    var $element = $('.product-reviews');

    if (!$element.length) {
      return false;
    }

    $('html, body')
      .stop()
      .animate(
        {
          scrollTop: $element.offset().top - 70
        },
        1000
      );
  },

  openReview: function openReview(event) {
    event && event.preventDefault();

    Modal.open({
      title: 'Avalie esse Produto',
      body: (document.querySelector(reviewsForm) || {}).outerHTML || '',
      windowTopClass: 'small-modal',
      onOpen: function ($modal) {
        const me = blz.me || {};
        const name =
          search.givenName || me.nickName || `${me.givenName || ''} ${me.familyName || ''}`;
        const email = search.email || me.email || '';
        const reviewBody = search.reviewBody || '';
        const rating = search.rating || 5;

        $modal.querySelector('input[name="givenName"]').value = name;
        $modal.querySelector('input[name="email"]').value = email;
        $modal.querySelector('#reviewBody').value = reviewBody;
        $modal.querySelector('#ratingValue').value = rating;
        Reviews.ratingValue('#genericModal');
      }
    });
  },

  ratingValue: function ratingValue(wrapper) {
    var $ratingValue = $('.rating-value', wrapper || document);
    if ($ratingValue.length && $ratingValue.rating) {
      $ratingValue.rating();
    }
  },

  upvote: function upvote(event) {
    var id = $(this).data('id');

    if (!blz.me.email || !id) {
      return true;
    }

    event.preventDefault();

    ReviewsService.upvote(id)
      .then(function () {
        NotificationService.success('Like contabilizado.');
        ReviewsService.count(event);
      })
      .catch(NotificationService.warning);
  },

  downvote: function downvote(event) {
    var id = $(this).data('id');

    if (!blz.me.email || !id) {
      return true;
    }

    event.preventDefault();

    ReviewsService.downvote(id)
      .then(function () {
        NotificationService.success('Dislike contabilizado.');
        ReviewsService.count(event);
      })
      .catch(NotificationService.warning);
  }
};

$reviewsScroll.on('click tap', Reviews.scroll);
$reviews.on('click tap', Reviews.openReview);

$('body')
  .on('submit', reviewsForm, Reviews.avaliate)
  .on('click tap', '.js-reviews-upvote', Reviews.upvote)
  .on('click tap', '.js-reviews-downvote', Reviews.downvote);

if (/openreview|reviewBody/i.test(window.location.href) && /products/.test(blz.pageName)) {
  // using timeout to prevent bootstrap modal bug
  setTimeout(Reviews.openReview, 100);
}

if (/#product-reviews/.test(window.location.hash) && /products/.test(blz.pageName)) {
  // ensure to scroll at review module (lazyload showcase changes position top of review module)
  Reviews.scroll();
  setTimeout(function () {
    Reviews.scroll();
  }, 900);
}

module.exports = Reviews;
